import { Flex } from '@chakra-ui/react'

import { Granularity, MeetingBookedData, TimeFrame } from '../types'
import { ConversionFunnel } from './ConversionFunnel'
import { SubmissionsOverTime } from './SubmissionsOverTime'

type Props = {
	meetingsBookedData: MeetingBookedData[] | undefined
	granularity: Granularity
	timeFrame: TimeFrame
	isLoading: boolean
}

export const FormAnalytics = ({
	meetingsBookedData,
	granularity,
	timeFrame,
	isLoading,
}: Props) => {
	return (
		<Flex direction="column" gap={8}>
			<ConversionFunnel
				meetingsBookedData={meetingsBookedData}
				isLoading={isLoading}
			/>
			<SubmissionsOverTime
				meetingsBookedData={meetingsBookedData}
				granularity={granularity}
				timeFrame={timeFrame}
				isLoading={isLoading}
			/>
		</Flex>
	)
}
